export const editInstructions = [
  "Select a card: Click a card in the display to the right to select it for editing.",
  'Change card type: Click the "Change card type" dropdown to change the type of the currently selected card.',
  "Change card text: Use the text boxes below to write text for the currently selected card. You can include line breaks. Do not use semi-colons (;).",
  "Rotate a card: Click the rotate buttons to change the orientation of the cues on a card.",
  'Delete a card:  Click "Delete This Card" to remove the currently selected card from the deck.',
  'Create a new card: Click "Create New Card" to generate and select a new blank card. It will match the type of the card currently selected.',
];

export const designInstructions = [
  "Change deck design: Use the dropdown menus to choose the design used for the card fronts and the card backs.",
  '"Original": matches the official version of The Story Engine deck.',
  '"Light": is an ink-friendly variant of the official version.',
  '"Minimalist": saves ink and is recommended for black and white decks.',
];

export const manageInstructions = [
  'Print Your Deck: Click "Print" to print your current deck. If your computer has a print-to-PDF function, you can save your designed print sheets for later.',
  'Start Over: Click "Reset Deck" to clear all cards and start over.',
  'Save Deck: Click "Save Deck" to download your deck data as an editable CSV spreadsheet that you can load and edit later.',
  'Load Deck: Click "Load Deck" to upload a CSV of deck data that you previously downloaded and continue editing it.',
];
